import React from 'react'
import { Route } from 'react-router-dom'
import { Navigate } from 'router'
import { useTranslation } from 'react-i18next'

import { useHasSitesOnProduction } from 'store'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'
import EmptyScreen from 'packages/ui/EmptyScreen'

import Coupons from './Coupons'
import CreateCoupon from './Form'
import Card from './Card'
import Edit from 'pages/Coupons/Actions/Edit'
import SendCode from 'pages/Coupons/Actions/SendCode'
import Export from 'pages/Coupons/Actions/Export'
import DisableCode from './Actions/DisableCode'

const Layout = () => {
  const {t} = useTranslation()
  const hasSitesOnProduction = useHasSitesOnProduction()
  return hasSitesOnProduction
    ? <Coupons />
    : <EmptyScreen icon="wifi">{t('ui_elements.service_soon')}</EmptyScreen>
}
export const CouponsRoutes = () => [
  <Route path="codes" element={<Navigate pathname="standard" />} exact key={'codes'}/>,
  <Route path="codes/standard" element={
    <RouteGuard requiredRoles={['codes']}>
      <Layout>
        <Coupons />
      </Layout>
    </RouteGuard>
  } key={'codes-standard'}>
    <Route path="new" element={<CreateCoupon />} />
    <Route path="export" element={<Export />} />
    <Route path=":id" element={<Card />}>
      <Route path="new" element={<CreateCoupon />} />
      <Route path="export" element={<Export />} />
      <Route path="edit" element={<Edit />} />
      <Route path="send-sms" element={<SendCode />} />
      <Route path="disable-code" element={<DisableCode />} />
    </Route>
  </Route>,
  <Route path="codes/h3" element={
    <RouteGuard requiredRoles={['codes']}>
      <Layout>
        <Coupons />
      </Layout>
    </RouteGuard>
  } key={'codes-h3'}>
    <Route path="export" element={<Export />} />
    <Route path="send-sms" element={<SendCode />} />
    <Route path=":id" element={<Card />}>
      <Route path="export" element={<Export />} />
      <Route path="send-sms" element={<SendCode />} />
    </Route>
  </Route>
]

export default CouponsRoutes